import { Injectable } from '@angular/core';
//import * as Rx from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the WebsocketService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class WebSocketService {

	ws: any;
	wsObservable: any;

	initializeWebSocket(url) {
		this.wsObservable = Observable.create((observer) => {
			this.ws = new WebSocket(url);

			this.ws.onopen = (e) => {
				console.log("WS Open")
			};

			this.ws.onclose = (e) => {
				if (e.wasClean) {
					observer.complete();
				} else {
					observer.error(e);
				}
			};

			this.ws.onerror = (e) => {
				observer.error(e);
			}

			this.ws.onmessage = (e) => {
				observer.next(JSON.parse(e.data));
			}

			return () => {
				this.ws.close();
			};
		}).share();
	}

	// sendData(message) {
	// 	this.ws.send(JSON.stringify(message));
	// }
}



// WEBPACK FOOTER //
// ./src/providers/websocket-service.ts